import toast from '../utils/toast'
import {
  /**
   * @description Actions for clubs requests
   */
  IS_LOADING,
  IS_LOADED,
  GET_CLUBS,
  CREATE_CLUB,
  DELETE_CLUB
} from '../constants'

import { clubs } from '../api'

export const getClubs = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: IS_LOADING })

      const response = await clubs.getClubs()

      dispatch({
        type: GET_CLUBS,
        clubs: response.data
      })

      dispatch({ type: IS_LOADED })
    } catch (e) {
      dispatch({ type: IS_LOADED })
      toast({
        title: e.response.data.message,
        type: e.response.data.type
      })
    }
  }
}

export const createClub = (values) => {
  return async (dispatch) => {
    try {
      const response = await clubs.createClub(values)
      const club = response.data.club

      dispatch({
        type: CREATE_CLUB,
        club
      })

      toast({
        title: response.data.message,
        type: response.data.type
      })
    } catch (e) {
      toast({
        title: e.response.data.message,
        type: e.response.data.type
      })
    }
  }
}

export const deleteClub = ({ clubId }) => {
  return async (dispatch) => {
    try {
      const response = await clubs.deleteClub({ clubId })

      dispatch({
        type: DELETE_CLUB,
        club: { id: clubId }
      })

      toast({
        title: response.data.message,
        type: response.data.type
      })
    } catch (e) {
      toast({
        title: e.response.data.message,
        type: e.response.data.type
      })
    }
  }
}
